// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentKioskOrderCompleteModal/style.css
// module id = 1978
// module chunks = 0